(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-bar"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
    $('.logosNew').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-logo"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
    setTimeout(function() {
    $('.logosNew').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  });
  }, 1000); // 1000ms = 1 second delay
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-sec-logo"] && !Shopify.designMode) return;
  try {
    
    $(document).ready(function(){
    setTimeout(function() {
    $('.logosNew').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });
  }, 1000); // 1000ms = 1 second delay
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multistep-form"] && !Shopify.designMode) return;
  try {
    
    /************* hiding model for images ***/

    document.getElementById("model-feature-images").style.display="none";

    /* hidign inside images div ********/
    document.getElementById("featureimg-tl").style.display="none";
    document.getElementById("featureimg-rsc").style.display="none";
    document.getElementById("featureimg-retail").style.display="none";
    document.getElementById("modaldesignimg1").style.display="none";
    document.getElementById("modaldesignimg2").style.display="none";

     /************** hiding error msg fields ********/
    document.getElementById("quantityError").style.display="none";
    const allerrorfields = document.querySelectorAll(".errorMsg");
    for(let i=0; i < allerrorfields.length; i++){
      allerrorfields[i].style.display="none";
    }
    document.getElementById("productSelectionErrorMsg").style.display="none";
    document.getElementById("special-msg").style.display="none";

    let tlboxstyleprice;
    let tlboxmaterialprice;
    let tlboxdimensionprice;
    let tlboxprintsurfaceprice;
    let tlboxcustomfileprice;
    let customMessage;

   let totalsum=0;

    /***** error msg color *******/
    document.getElementById("quantityError").style.color="red";
     /************** hiding error msg fields ********/

  const multiStepForm = document.querySelector(".data-multi-step")
  const formSteps = [...multiStepForm.querySelectorAll("[data-step]")]
  const progressSteps = document.querySelectorAll(".step-col");
  let currentStep = formSteps.findIndex(step => {
    return step.classList.contains("active")
  })

  if (currentStep < 0) {
    currentStep = 0
    showCurrentStep()
  }

  multiStepForm.addEventListener("click", e => {
    let incrementor
    if (e.target.matches("[data-next]")) {

        incrementor = 1
        const inputs = [...formSteps[currentStep].querySelectorAll("input")]
        const allValid = inputs.every(input => input.reportValidity())
        var selectBool = false;
        const selectSelected = [...formSteps[currentStep].querySelectorAll("select")]

        console.log("Count of all selects : "+selectSelected.length);

        if(selectSelected.length == 0){
          var selectBool = true;
        }else{


            for (let i = 0; i < selectSelected.length; i++) {

            if(selectSelected[i].options[selectSelected[i].selectedIndex].index == 0){
              console.log("not selected anyone (index of selected item) : "+selectSelected[i].options[selectSelected[i].selectedIndex].index)
              continue;
               var selectBool = false;
                  console.log(" not selected : "+selectBool)
              }else
              {
                console.log("Index of selcted item : "+selectSelected[i].options[selectSelected[i].selectedIndex].index)

                    var selectBool = true;
                    console.log(" Yes selected : "+selectBool)
                    console.log("Selected index :- "+selectSelected[0].options[selectSelected[0].selectedIndex].index);
                  }

                }
          }
            if ( allValid && selectBool){
            currentStep += incrementor
            showCurrentStep()
            progressSteps.forEach((progressStep, index) =>{
            if(index < currentStep + 1){
              console.log("index : "+index);
              console.log("currentStep : "+currentStep);
              if(index == 6){
                console.log("index is 6 ")
                progressStep.classList.add('no-before');
              }
                progressStep.classList.add('progress-step-active');
              }else{
                    progressStep.classList.remove('progress-step-active');
                    }
              })


            }else{

                 const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
                 console.log("errorMsg element: "+errorMsg)
                 errorMsg.style.display="inline-block";
                 errorMsg.style.color="red";
                 }

        } /********* else previous button clicked event start*******/
          else if (e.target.matches("[data-previous]")) {
              console.log("Prev button selected ")
              incrementor = -1
               currentStep += incrementor
                showCurrentStep()
                  progressSteps.forEach((progressStep, index) =>{
                    if(index < currentStep + 1){
                      progressStep.classList.add('progress-step-active');

                      progressStep.style.setProperty('--aftertrans',"all");
                      progressStep.style.setProperty('--aftertransdur',".1s");
                      progressStep.style.setProperty('--aftertransfunc',"ease-in");



                      }else{
                          progressStep.classList.remove('progress-step-active');
                            }
                    })
            }
    /********* else previous button clicked event end*******/
        if (incrementor == null) return



  });

  formSteps.forEach(step => {
    step.addEventListener("animationend", e => {
      formSteps[currentStep].classList.remove("hide")
      e.target.classList.toggle("hide", !e.target.classList.contains("active"))
    })


  })

    function showCurrentStep() {
    formSteps.forEach((step, index) => {
      step.classList.toggle("active", index === currentStep)
    })
  }

    /************* on progress bar click ****************/

     const click1 = document.getElementById("step-1")
    click1.addEventListener("click", function(){
      currentSlide(1);
    })

    const click2 = document.getElementById("step-2")
    click2.addEventListener("click", function(){
      currentSlide(2);
    })

    const click3 = document.getElementById("step-3")
    click3.addEventListener("click", function(){
      currentSlide(3);
    })
    const click4 = document.getElementById("step-4")
    click4.addEventListener("click", function(){
      currentSlide(4);
    })
     const click5 = document.getElementById("step-5")
    click5.addEventListener("click", function(){
      currentSlide(5);
    })
     const click6 = document.getElementById("step-6")
    click6.addEventListener("click", function(){
      currentSlide(6);
    })
    const click7 = document.getElementById("step-7")
    click6.addEventListener("click", function(){
      currentSlide(7);
    })

     function currentSlide(n){
       showCurrentStep(currentStep = n);
        progressSteps.forEach((progressStep, index) =>{
        if(index < currentStep + 1){
          console.log("currentstp" + currentStep);
            progressStep.classList.add('progress-step-active');
           if(currentStep == 6){
             progressStep.style.setProperty('--aftertrans',"none");

           }else{
            progressStep.style.setProperty('--aftertrans',"all");
            progressStep.style.setProperty('--aftertransdur',".1s");
            progressStep.style.setProperty('--aftertransfunc',"ease-in");
            progressStep.style.setProperty('--aftertransdel',".3s");
           }

        }else{
          progressStep.classList.remove('progress-step-active');
        }
      })
     }

  <!--custom code-->


  <!--custom code end here-->

    /************* on progress bar click ****************/

    /************ conditional logic of next steps ***********/
  document.getElementById("product-material-TL").style.display="none";
  document.getElementById("product-material-RSC").style.display="none";
  document.getElementById("product-material-retail-box").style.display="none";

  document.getElementById("product-dimension-retail-box").style.display="none";
  document.getElementById("product-dimension-tl").style.display="none";
  document.getElementById("product-dimension-rsc").style.display="none";



    /****** when Box Style is selcted *******/

  document.getElementById("product-features").addEventListener('change', function(){
   if(this.value=="TL"){
      document.getElementById("product-material-TL").style.display="block";
      document.getElementById("product-material-RSC").style.display="none";
      document.getElementById("product-material-retail-box").style.display="none";
      document.getElementById("product-dimension-tl").style.display="block";
      document.getElementById("product-dimension-rsc").style.display="none";
      document.getElementById("product-dimension-retail-box").style.display="none"

    } else if (this.value=="RSC"){
      document.getElementById("product-material-TL").style.display="none";
      document.getElementById("product-material-RSC").style.display="block";
      document.getElementById("product-material-retail-box").style.display="none";
      document.getElementById("product-dimension-tl").style.display="none";
      document.getElementById("product-dimension-rsc").style.display="block";
      document.getElementById("product-dimension-retail-box").style.display="none";
    }
    else if (this.value=="Retail box"){
      document.getElementById("product-material-TL").style.display="none";
      document.getElementById("product-material-RSC").style.display="none";
      document.getElementById("product-material-retail-box").style.display="block";
      document.getElementById("product-dimension-tl").style.display="none";
      document.getElementById("product-dimension-rsc").style.display="none";
      document.getElementById("product-dimension-retail-box").style.display="block";
    }

  });
     /****** when box style is selcted *******/



  /************** multisteps form data retrieval css ****************/

     /*********** step1 data retrieval ***/
    var OutputProductName = document.getElementById("product-name");

    document.getElementById("step1image1").addEventListener('change', boxClicked);

    function boxClicked(){
      let prodName;
      var label1 = document.getElementById('labelImg1');
      var checkBox = document.getElementById("step1image1");

      if(checkBox.checked == true){
        prodName = checkBox.value;
        OutputProductName.innerHTML = prodName;
        OutputProductName.value = prodName;
        document.getElementById("next1").style.display="none";
        document.getElementById("next2").style.display="block";
        document.getElementById("productSelectionErrorMsg").style.display="none";
      }
      else if(checkBox.checked == false)
      {
            label1.style.setProperty('--afterback','transparent');
            OutputProductName.innerHTML = "";
            OutputProductName.value = "";
      }
      console.log("Product is :"+prodName);
      document.getElementById("outputProductName").innerHTML= prodName;
    }

     /*********** step2 data retrieval ********/

    var featureDropDown = document.getElementById("product-features");
   featureDropDown.onchange = (e) => {

               /***** hiding error msg *************/
               const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
                errorMsg.style.display="none";
               /***** hiding error msg *************/

     //console.log("Product Feature is: "+featureDropDown.value);
     console.log("Feature is: "+featureDropDown.value);
    document.getElementById("outputProductFeatures").innerHTML = featureDropDown.value;
  if (featureDropDown.value == 'TL' || featureDropDown.value == 'RSC' || featureDropDown.value == 'Retail box') {
    document.getElementById('next3').style.display = 'none';
    document.getElementById('next-3').style.display = 'block';
  }

  if (featureDropDown.value == 'Retail box') {
    document.getElementById('next3').style.display = 'none';
    document.getElementById('next-3').style.display = 'block';
  } else {
    document.getElementById('next3').style.display = 'block';
    document.getElementById('next-3').style.display = 'none';
  }
     //console.log("Product Feature price is: "+featureDropDown.options[featureDropDown.selectedIndex].dataset.price);
     tlboxstyleprice = featureDropDown.options[featureDropDown.selectedIndex].dataset.price;

     totalsum +=parseInt(tlboxstyleprice);

  //   document.getElementById("costPerBox").innerHTML="$"+featureDropDown.options[featureDropDown.selectedIndex].dataset.price+" per Box";
     document.getElementById("outputProductFeatures").innerHTML = featureDropDown.value;

   }

   /*********** step3 data retrieval *************/

    document.getElementById("product-material-TL").addEventListener('change', function(){

       document.getElementById('next3').style.display = 'none';
       document.getElementById('next-3').style.display = 'block';
        /***** hiding error msg *************/
               const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
                errorMsg.style.display="none";
        /***** hiding error msg *************/

      var materialDropDown = document.getElementById("product-material-TL");
       var active_class = $('select[name="contact[product material]"]').find(':selected').attr('class');
      $('#step-3 ul.option-img-material li').removeClass('active');
      $('#'+active_class).parent().addClass('active');

     console.log("Materials selected is for TL :"+materialDropDown.value);

     //console.log("Product Material for tl price is: "+materialDropDown.options[materialDropDown.selectedIndex].dataset.price);
     tlboxmaterialprice = materialDropDown.options[materialDropDown.selectedIndex].dataset.price;

      totalsum +=parseInt(tlboxmaterialprice);
      console.log("total is : "+totalsum)

     document.getElementById("outputProductMaterial").innerHTML = materialDropDown.value;

    });

     document.getElementById("product-material-RSC").addEventListener('change', function(){
   document.getElementById('next3').style.display = 'none';
       document.getElementById('next-3').style.display = 'block';
       /***** hiding error msg *************/
               const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
                errorMsg.style.display="none";
        /***** hiding error msg *************/

      var materialDropDown = document.getElementById("product-material-RSC");
     console.log("Materials selected is for RSC :"+materialDropDown.value);
       var active_class = $('select[name="contact[product material2]"]').find(':selected').attr('class');
      $('#step-3 ul.option-img-material li').removeClass('active');
      $('#'+active_class).parent().addClass('active');

    // console.log("Product Material price for RSC is: "+materialDropDown.options[materialDropDown.selectedIndex].dataset.price);
     tlboxmaterialprice = materialDropDown.options[materialDropDown.selectedIndex].dataset.price;

     totalsum +=parseInt(tlboxmaterialprice);

      document.getElementById("outputProductMaterial").innerHTML = materialDropDown.value;

    });

      document.getElementById("product-material-retail-box").addEventListener('change', function(){
   document.getElementById('next3').style.display = 'none';
       document.getElementById('next-3').style.display = 'block';
        /***** hiding error msg *************/
               const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
                errorMsg.style.display="none";
        /***** hiding error msg *************/

      var materialDropDown = document.getElementById("product-material-retail-box");
     console.log("Materials selected is for Retail Box :"+materialDropDown.value);
        var active_class = $('select[name="contact[product material3]"]').find(':selected').attr('class');
      $('#step-3 ul.option-img-material li').removeClass('active');
      $('#'+active_class).parent().addClass('active');

     console.log("Product Material price for pb is: "+materialDropDown.options[materialDropDown.selectedIndex].dataset.price);
     tlboxmaterialprice = materialDropDown.options[materialDropDown.selectedIndex].dataset.price;

     totalsum +=parseInt(tlboxmaterialprice);

      document.getElementById("outputProductMaterial").innerHTML = materialDropDown.value;

    });


    /*********** step4 data retrieval ***/

  document.getElementById("product-dimension-tl").addEventListener('change', function() {
    /***** hiding error msg *************/
    const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
    errorMsg.style.display = "none";
    /***** hiding error msg *************/

    var dimensionDropDown = document.getElementById("product-dimension-tl");
    console.log("Product dimension for tl is: " + dimensionDropDown.value);

    console.log("Product dimension for tl price is: " + dimensionDropDown.options[dimensionDropDown.selectedIndex].dataset.price);
    var tlboxdimensionprice = parseInt(dimensionDropDown.options[dimensionDropDown.selectedIndex].dataset.price);

    // Subtract the previous price from the totalsum
    totalsum -= parseFloat(dimensionDropDown.previousPrice) || 0;

    // Update the totalsum with the new price
    totalsum += tlboxdimensionprice;

    // Store the new price as the previous price
    dimensionDropDown.previousPrice = tlboxdimensionprice;

    console.log("total is : " + totalsum);

    document.getElementById("outputProductDimension").innerHTML = dimensionDropDown.value;

    // var length= $('.length').val();
    //   var width = $('.width').val();
    //   var height = $('.height').val();
    //     console.log(length +' X '+ width +' X '+ height);
    //   var demensions= (length +' X '+ width +' X '+ height);
    //   console.log(demensions)
    //   document.getElementById("outputProductDimension1").innerHTML = demensions;
  });

  document.getElementById("product-dimension-rsc").addEventListener('change', function() {
    /***** hiding error msg *************/
    const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
    errorMsg.style.display = "none";
    /***** hiding error msg *************/

    var dimensionDropDown = document.getElementById("product-dimension-rsc");
    console.log("Product dimension for rsc is: " + dimensionDropDown.value);

    console.log("Product dimension for rsc price is: " + dimensionDropDown.options[dimensionDropDown.selectedIndex].dataset.price);
    var tlboxdimensionprice = parseInt(dimensionDropDown.options[dimensionDropDown.selectedIndex].dataset.price);

    // Subtract the previous price from the totalsum
    totalsum -= parseFloat(dimensionDropDown.previousPrice) || 0;

    // Update the totalsum with the new price
    totalsum += tlboxdimensionprice;

    // Store the new price as the previous price
    dimensionDropDown.previousPrice = tlboxdimensionprice;

    console.log("total is : " + totalsum);

    document.getElementById("outputProductDimension").innerHTML = dimensionDropDown.value;

     // var length= $('.length').val();
     //  var width = $('.width').val();
     //  var height = $('.height').val();
     //    console.log(length +' X '+ width +' X '+ height);
     //  var demensions= (length +' X '+ width +' X '+ height);
     //  console.log(demensions)
     //  document.getElementById("outputProductDimension1").innerHTML = demensions;
  });

    // custom code
    $('button#next5').click(function(){
        var length= $('.display-flex.align-items-center.length input[name="contact[box-length]"]').val();
        var width = $('.display-flex.align-items-center.width input[name="contact[box-width]"]').val();
      var height = $('.display-flex.align-items-center.height input[name="contact[box-height]"]').val();
      // if (length == ''){
      //   $('.display-flex.align-items-center input[name="box-length"]').prop('required',true);
      // }
      // if (width == ''){
      //   $('.display-flex.align-items-center input[name="box-width"]"]').prop('required',true);
      // }
      // if (height == ''){
      //   $('.display-flex.align-items-center input[name="box-length"]"]').prop('required',true);
      // }
        console.log(length +' X '+ width +' X '+ height);
      var demensions= (length +' X '+ width +' X '+ height);
      console.log(demensions)
      document.getElementById("outputProductDimension1").innerHTML = demensions;
  });

  document.getElementById("product-dimension-retail-box").addEventListener('change', function() {
    /***** hiding error msg *************/
    const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
    errorMsg.style.display = "none";
    /***** hiding error msg *************/

    var dimensionDropDown = document.getElementById("product-dimension-retail-box");
    console.log("Product dimension for product box is: " + dimensionDropDown.value);

    console.log("Product dimension for pb price is: " + dimensionDropDown.options[dimensionDropDown.selectedIndex].dataset.price);
    var tlboxdimensionprice = parseInt(dimensionDropDown.options[dimensionDropDown.selectedIndex].dataset.price);

    // Subtract the previous price from the totalsum
    totalsum -= parseFloat(dimensionDropDown.previousPrice) || 0;

    // Update the totalsum with the new price
    totalsum += tlboxdimensionprice;

    // Store the new price as the previous price
    dimensionDropDown.previousPrice = tlboxdimensionprice;

    console.log("total is : " + totalsum);

    document.getElementById("outputProductDimension").innerHTML = dimensionDropDown.value;

      // var length= $('.length').val();
      // var width = $('.width').val();
      // var height = $('.height').val();
      //   console.log(length +' X '+ width +' X '+ height);
      // var demensions= (length +' X '+ width +' X '+ height);
      // console.log(demensions)
      // document.getElementById("outputProductDimension1").innerHTML = demensions;
  });


    /*********** step5 data retrieval ***/


  var productSurfaceDropDown = document.getElementById("product-surface");
  productSurfaceDropDown.onchange = (e) => {

    /***** hiding error msg *************/
    const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
    errorMsg.style.display = "none";
    /***** hiding error msg *************/

    console.log("Product packaging surface is: " + productSurfaceDropDown.value);

    console.log("Product surface for tl price is: " + productSurfaceDropDown.options[productSurfaceDropDown.selectedIndex].dataset.price);
    tlboxprintsurfaceprice = parseFloat(productSurfaceDropDown.options[productSurfaceDropDown.selectedIndex].dataset.price);

    // Subtract the previous price from the totalsum
    totalsum -= parseFloat(productSurfaceDropDown.dataset.previousPrice) || 0;

    // Update the totalsum with the new price
    totalsum += tlboxprintsurfaceprice;

    // Store the new price as the previous price
    productSurfaceDropDown.dataset.previousPrice = tlboxprintsurfaceprice;

    console.log("total is: " + totalsum)

    document.getElementById("outputProductDesign").innerHTML = productSurfaceDropDown.value + "<br/>";
  //  document.getElementById("totalPrice").innerHTML = "$ " + totalsum.toLocaleString("en-US");
  }

  document.getElementById("custom-design-file").addEventListener('change', function (myfile) {

    /************* hiding error msg *************/
    const errorMsg = formSteps[currentStep].getElementsByClassName("errorMsg")[0];
    errorMsg.style.display = "none";
    /************* hiding error msg *************/

    var filetype = document.getElementById("custom-design-file");
    var file = myfile.target.files[0];
    var filename = file.name;
    console.log("Uploaded File name is: " + filename)

    console.log("Product surface for tl price is: " + filetype.dataset.price);
    tlboxcustomfileprice = parseFloat(filetype.dataset.price);

    // Subtract the previous price from the totalsum
    totalsum -= parseFloat(filetype.dataset.previousPrice) || 0;

    // Update the totalsum with the new price
    totalsum += tlboxcustomfileprice;

    // Store the new price as the previous price
    filetype.dataset.previousPrice = tlboxcustomfileprice;

    console.log("total is : " + totalsum)

    document.getElementById("outputProductDesign").innerHTML += "Art: " + filename;

    document.getElementById("totalPrice").value = "$ " + totalsum.toLocaleString("en-US");
  });

  document.getElementById("comment").addEventListener('input', function () {


    var specialComment = document.getElementById("comment");
    console.log("Product special message price is:" + specialComment.dataset.price);
    customMessage = parseFloat(specialComment.dataset.price);
    // Subtract the previous price from the totalsum
    totalsum -= parseFloat(specialComment.dataset.previousPrice) || 0;

    // Update the totalsum with the new price
    totalsum += customMessage;

    // Store the new price as the previous price
    specialComment.dataset.previousPrice = customMessage;

    console.log("total is : " + totalsum)

    document.getElementById("special-msg").style.display = "block";
    document.getElementById("print-special-msg").value = specialComment.value;


    // cstm

     var comments = document.getElementById("comment");
    var content = comments.value;
      console.log("Setting value: " + content);

     var msg = document.getElementById("print-special-msg");
       msg.innerHTML = content;


  });





  /************** multisteps form data retrieval css ****************/

  /************** multisteps form data display css ****************/
  /****** displaying model for imags ********************/


    document.getElementById("feature_tl_img").addEventListener("click", function(){
        document.getElementById("model-feature-images").style.display="none";
        document.getElementById("featureimg-tl").style.display="block";
        document.getElementById("featureimg-rsc").style.display="none";
        document.getElementById("featureimg-retail").style.display="none";
        document.getElementById("modaldesignimg1").style.display="none";
        document.getElementById("modaldesignimg2").style.display="none";

    })
    document.getElementById("feature_t2_img").addEventListener("click", function(){
        document.getElementById("model-feature-images").style.display="none";
        document.getElementById("featureimg-rsc").style.display="block";
        document.getElementById("featureimg-tl").style.display="none";
        document.getElementById("featureimg-retail").style.display="none";
        document.getElementById("modaldesignimg1").style.display="none";
        document.getElementById("modaldesignimg2").style.display="none";

    })
    document.getElementById("feature_t3_img").addEventListener("click", function(){
        document.getElementById("model-feature-images").style.display="none";
        document.getElementById("featureimg-retail").style.display="block";
        document.getElementById("featureimg-rsc").style.display="none";
        document.getElementById("featureimg-tl").style.display="none";
        document.getElementById("modaldesignimg1").style.display="none";
        document.getElementById("modaldesignimg2").style.display="none";

    })

    document.getElementById("designimg1").addEventListener("click", function(){
        document.getElementById("model-feature-images").style.display="none";
        document.getElementById("modaldesignimg1").style.display="block";
        document.getElementById("modaldesignimg2").style.display="none";
        document.getElementById("featureimg-retail").style.display="none";
        document.getElementById("featureimg-rsc").style.display="none";
        document.getElementById("featureimg-tl").style.display="none";

    })

    document.getElementById("designimg2").addEventListener("click", function(){
        document.getElementById("model-feature-images").style.display="none";
        document.getElementById("modaldesignimg1").style.display="none";
        document.getElementById("modaldesignimg2").style.display="block";
        document.getElementById("featureimg-retail").style.display="none";
        document.getElementById("featureimg-rsc").style.display="none";
        document.getElementById("featureimg-tl").style.display="none";

    })

  /****** closing model for imags ********************/
    document.getElementById("featureimgclose").addEventListener("click", function(){
       document.getElementById("model-feature-images").style.display="none";
    })

  } catch(e) { console.error(e); }
})();
})();
